import { gql } from '@apollo/client';

export const getEncodeConfigSettings = gql`
  query getEncodeConfigSettings {
    getEncodeConfigSettings {
      status
      results{
       name
       value
      }
    }
  }
`;

export const updateListSettings = `
    query (
        $id:Int,
        $typeId:Int,
        $itemName:String,
        $itemDescription:String,
        $otherItemName:String,
        $maximum:Int,
        $minimum:Int,
        $startValue:Int,
        $endValue:Int,
        $isEnable: String,
        $image: String
      ) {
          updateListSettings (
            id: $id,
            typeId:$typeId,
            itemName:$itemName,
            itemDescription:$itemDescription,
            otherItemName: $otherItemName,
            maximum: $maximum,
            minimum: $minimum,
            startValue: $startValue,
            endValue: $endValue,
            isEnable: $isEnable,
            image: $image
          ) {
            status
          }
        }
    `;

export const getAllAdminListSettings = gql`
    query ($currentPage: Int,$typeId: Int) {
    	getAllAdminListSettings(currentPage: $currentPage,typeId: $typeId){
        status
        errorMessage
        listSettingsTypeData {
          id
          typeName
          typeLabel
          fieldType
        }
        count
        listSettingsData {
          id
          typeId
          itemName
          itemDescription
          otherItemName
          startValue
          endValue
          maximum
          minimum
          isEnable
          image
      	}
    	}  	
    }
    `;

export const deleteListSettings = gql`
    query($id:Int, $typeId: Int) {
      deleteListSettings(id: $id, typeId: $typeId){
        status
        }
      }
    `;

export const updateSiteSettings = `
    query (
      $siteName: String,
      $siteTitle: String,
      $metaDescription: String,
      $metaKeyword: String,
      $logo: String,
      $facebookLink: String,
      $twitterLink: String,
      $instagramLink: String
      $homePageType: Int,
      $phoneNumberStatus: Int,
      $homeLogo: String,
      $emailLogo: String,
      $appAvailableStatus: Boolean,
      $playStoreUrl: String,
      $appStoreUrl: String,
      $email: String,
      $phoneNumber: String,
      $address: String,
      $listingApproval: String,
      $appForceUpdate: String,
      $androidVersion: String,
      $iosVersion: String,
      $ogImage: String
    ) {
      updateSiteSettings (
        siteName: $siteName,
        siteTitle: $siteTitle,
        metaDescription: $metaDescription,
        metaKeyword: $metaKeyword,
        logo: $logo,
        facebookLink: $facebookLink,
        twitterLink: $twitterLink,
        instagramLink: $instagramLink,
        homePageType: $homePageType,
        phoneNumberStatus: $phoneNumberStatus,
        homeLogo: $homeLogo,
        emailLogo: $emailLogo,
        appAvailableStatus: $appAvailableStatus,
        playStoreUrl: $playStoreUrl,
        appStoreUrl: $appStoreUrl,
        email: $email,
        phoneNumber: $phoneNumber,
        address: $address,
        listingApproval: $listingApproval,
        appForceUpdate: $appForceUpdate,
        androidVersion: $androidVersion,
        iosVersion: $iosVersion
        ogImage: $ogImage
      ) {
          status
      }
    }
    `;


export const configSettings = gql`query ($type: String) {
      siteSettings(type: $type) {
        name
        encryptValue
      }
    }`;

export const updateSettingsData = gql`mutation updateSpecificSiteSettings(
      $fieldName: String,
      $value: String,
      ) {
          updateSpecificSiteSettings(
              fieldName: $fieldName
              value: $value
          ){
              status
          }
      }`;